import { questionnaireApi } from './apis';
import { convertToQueryString } from '@utils';
import { AxiosResponse } from 'axios';
import {
  GenericItemsResponseInterface,
  QuestionnaireEntityInterface,
  QuestionnaireQueryInterface,
} from '@types';

const ROUTES = {
  getQuestionnaireById: '/',
  getAllQuestionnaires: '/',
};

//caching for getSubmissionById
export const questionnaireCache = new Map<
  string,
  AxiosResponse<GenericItemsResponseInterface<QuestionnaireEntityInterface>>
>();

export const getQuestionnaireById = async (id: number): Promise<QuestionnaireEntityInterface> => {
  const response = await questionnaireApi.get(ROUTES.getQuestionnaireById + id);
  return response.data;
};

export const getAllQuestionnaires = async (
  query: QuestionnaireQueryInterface
): Promise<GenericItemsResponseInterface<QuestionnaireEntityInterface>> => {
  const cacheKey = JSON.stringify(query);
  if (questionnaireCache.has(cacheKey)) {
    return questionnaireCache.get(cacheKey).data;
  }
  const response = await questionnaireApi.get(
    ROUTES.getAllQuestionnaires + convertToQueryString(query)
  );
  questionnaireCache.set(cacheKey, response);

  return response.data;
};
